import { render, staticRenderFns } from "./b2b.vue?vue&type=template&id=3372472b&scoped=true&"
import script from "./b2b.vue?vue&type=script&lang=js&"
export * from "./b2b.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3372472b",
  null
  
)

export default component.exports